module.exports = __webpack_public_path__ + "media/images/vod_icons/akt-4e200a51d728ba096181ce03ab3153f2.svg";